import { useState } from 'react';
import type { Reason } from '../format/check';
import type { FormDefinition } from '../format/form-definition';
import { openFormDefinition } from '../format/open';
import { Builder } from './Builder';
import { newFormDefinition } from './new-form';
import { Alert } from 'framework/ui/mui-builder';

export interface FormBuilderProps {
  definition?: unknown;
  formLink?: string;
  onSave: (definition: FormDefinition) => Promise<void>;
  onUnsavedChange?: (hasUnsavedChanges: boolean) => void;
}

type Start = { form: FormDefinition; saved: FormDefinition | null } | { reasons: Reason[] };

export const FormBuilder = ({ definition, formLink, onSave, onUnsavedChange }: FormBuilderProps) => {
  const [start] = useState((): Start => {
    if (definition === undefined) return { form: newFormDefinition(), saved: null };
    const opened = openFormDefinition(definition);
    return opened.ok ? { form: opened.definition, saved: opened.definition } : { reasons: opened.reasons };
  });

  if ('reasons' in start) {
    return <Alert>This form can't be opened. ${start.reasons.map(reason => reason.text).join(' ')}</Alert>;
  }
  return (
    <Builder
      form={start.form}
      saved={start.saved}
      formLink={formLink}
      onSave={onSave}
      onUnsavedChange={onUnsavedChange}
    />
  );
};
